import { useSetState } from 'ahooks'
import { useDeepCompareEffect } from 'ahooks'
import { CheckList, Popup, SearchBar, SafeArea, Toast } from 'antd-mobile'
import classNames from 'classnames'
import { isNil } from 'lodash-es'
import { observer } from 'mobx-react'
import { useEffect, useContext } from 'react'

// ====================== 内部公共
import BlankBox from '@/components/BlankBox'
import HCell from '@/components/NewEditForm/UILibrary/HYBVant/HCell'
import HPopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup'
import { storeWithContext } from '@/store'
import { isNotEmptyArray } from '@/utils'

import { publicEvents } from '../../HYBVant/utils'

import useSetting from './useSetting'

import './index.less'

interface IProps {
  renderItem?: Function
  dataList?: any[]
  options?: any[]
  disabled?: boolean
  handleChange?: Function
  onChange?: Function
  onConfirm?: Function
  fieldNames?: any
  isSearch?: boolean
  title?: string
  store?: any
  value?: any
  label?: any
  required?: boolean
  mode?: string // single, multiple
  size?: string
  readed?: boolean
  className?: string
  onInitData?: Function
  onAfterChange?: Function
  placeholder?: string
}

function ListSelect(props: IProps) {
  const {
    value,
    dataList,
    options,
    isSearch = false,
    disabled = false,
    title = '',
    label = '',
    fieldNames = { value: 'value', label: 'name' },
    mode = 'single',
    required = false,
    onChange,
    onConfirm,
    renderItem,
    size,
    handleChange,
    readed = false,
    placeholder = '请选择',
    ...rest
  } = props

  console.log('ListSelect:', mode)
  const [{ show, searchText, checkedValue }, setState] = useSetState<any>({
    show: false,
    searchText: '',
    checkedValue: []
  })

  const _onConfirm = (e: any) => {
    publicEvents.onChange.call(props, e)
    onChange?.(e)
    onConfirm?.(e)
  }

  const { change, renderList, renderSelectedValue } = useSetting()

  const { list } = renderList({ dataList, options, fieldNames, searchText })

  const { selectedValue } = renderSelectedValue({ value, list, mode })

  const bool: boolean = !disabled && !readed

  const onClick = () => {
    bool &&
      setState({
        show: true
      })
  }
  const onClose = () => {
    setState({
      show: false
    })
  }

  useEffect(() => {
    setState({
      checkedValue:
        mode === 'single' ? [value].filter((item) => !isNil(item) && item !== '') : value || []
    })
  }, [value, show])

  useDeepCompareEffect(() => {
    if (
      typeof rest?.onInitData === 'function' &&
      (isNotEmptyArray(dataList) || isNotEmptyArray(options))
    ) {
      rest?.onInitData?.(isNotEmptyArray(dataList) ? dataList : options)
    }
  }, [dataList, options])

  console.log(value, list, checkedValue, 'ListSelect>>>>')

  return (
    <>
      {renderItem ? (
        renderItem(onClick, {
          value: selectedValue,
          readed,
          disabled,
          popupShow: show
        })
      ) : (
        <HCell
          className={rest.className || ''}
          value={selectedValue}
          readed={readed}
          onClick={onClick}
          disabled={disabled}
          placeholder={placeholder}
        />
      )}

      <HPopup
        visible={show}
        closeOnMaskClick={true}
        className={classNames('public-picker-popup', { sm: size === 'sm' })}
        onClose={onClose}
        renderHeader={() => {
          return (
            <div
              className={classNames(
                'public-picker-popup-content-header',
                `public-picker-popup-content-header-${mode}`
              )}
            >
              <div className='public-picker-popup-content-header-i' onClick={() => onClose()}>
                取消
              </div>
              <div className='public-picker-popup-content-header-title'>请选择{title || label}</div>
              <div
                className='public-picker-popup-content-header-i header-ok'
                onClick={() => {
                  if (mode !== 'multiple') return
                  if (required && checkedValue?.length === 0) {
                    Toast.show({
                      content: '请至少选择一项'
                    })
                    return
                  }
                  _onConfirm?.(checkedValue)
                  handleChange?.(checkedValue)
                  setState({
                    show: false
                  })
                }}
              >
                确定
              </div>
            </div>
          )
        }}
      >
        <div className='public-picker-popup-content'>
          {isSearch && (
            <div className='public-picker-popup-content-search'>
              <SearchBar
                placeholder='请输入'
                value={searchText}
                onChange={(v) => {
                  setState({
                    searchText: v
                  })
                }}
              />
            </div>
          )}
          {list?.length > 0 ? (
            <div className='public-picker-popup-content-list'>
              <CheckList
                multiple={mode === 'multiple'}
                value={checkedValue}
                onChange={(val) => {
                  // 单选必填，阻止取消行为：忽略空选择
                  const isSingleRequired = mode === 'single' && required && val?.length === 0

                  change({
                    val: isSingleRequired ? [value] : val,
                    mode,
                    setState,
                    handleChange,
                    options: list,
                    onChange: _onConfirm,
                    ...rest
                  })
                }}
              >
                {list?.map(({ key, ...item }: any) => (
                  <CheckList.Item
                    className='public-picker-popup-content-list-item'
                    key={key}
                    {...item}
                  >
                    <div className='public-picker-popup-content-list-label'>{item?.label}</div>
                  </CheckList.Item>
                ))}
              </CheckList>
            </div>
          ) : (
            <div className='public-picker-popup-content-not'>
              <BlankBox name='暂无数据' />
            </div>
          )}
          <SafeArea position='bottom' />
        </div>
      </HPopup>
    </>
  )
}

ListSelect.transform = (value: any, config: any) => {
  switch (config.mode) {
    case 'multiple':
      return value
    default:
      return Array.isArray(value) ? value?.[0] : value
  }
}
export default observer(ListSelect)
